import { accounting } from '../../api/accounting';
import { BrowserFourdApi } from '.';

export class Accounting implements accounting.Api {
  constructor(private fourd: BrowserFourdApi) {}

  createTimeEntry(request: accounting.CreateTimeEntryRequest): void {
    this.fourd.call4Dv2('accounting.createTimeEntry', request);
  }

  createFeeEntry(request: accounting.CreateFeeEntryRequest): void {
    this.fourd.call4Dv2('accounting.createFeeEntry', request);
  }

  createCostRecovery(request: accounting.CreateCostRecoveryEntryRequest): void {
    this.fourd.call4Dv2('accounting.createCostRecovery', request);
  }

  createInvoice(request: accounting.CreateInvoiceRequest): Promise<boolean> {
    return this.fourd.twoWayCall<accounting.CreateInvoiceRequest, boolean>(
      request,
      (requestId, request) => {
        this.fourd.call4Dv2('accounting.createInvoice', request, requestId);
      },
      (response) => {
        return true; // TODO: check the actual response
      }
    );
  }

  createOfficeReceipt(request: accounting.CreateOfficeReceiptRequest): void {
    this.fourd.call4Dv2('accounting.createOfficeReceipt', request);
  }

  createOfficePayment(request: accounting.CreateOfficePaymentRequest): void {
    this.fourd.call4Dv2('accounting.createOfficePayment', request);
  }

  createOfficeJournal(request: accounting.CreateOfficeJournalRequest): void {
    this.fourd.call4Dv2('accounting.createOfficeJournal', request);
  }

  createTrustReceipt(request: accounting.CreateTrustReceiptRequest): void {
    this.fourd.call4Dv2('accounting.createTrustReceipt', request);
  }

  createTrustPayment(request: accounting.CreateTrustPaymentRequest): void {
    this.fourd.call4Dv2('accounting.createTrustPayment', request);
  }

  createTrustJournal(request: accounting.CreateTrustJournalRequest): void {
    this.fourd.call4Dv2('accounting.createTrustJournal', request);
  }

  createTrustToOffice(request: accounting.CreateTrustToOfficeRequest): void {
    this.fourd.call4Dv2('accounting.createTrustToOffice', request);
  }
  createOfficePaymentRequest(request: accounting.CreateNewOfficePaymentRequestRequest): void {
    this.fourd.call4Dv2('accounting.createOfficePaymentRequest', request);
  }

  createTrustPaymentRequest(request: accounting.CreateNewTrustPaymentRequestRequest): void {
    this.fourd.call4Dv2('accounting.createTrustPaymentRequest', request);
  }

  reloadFinancialSummary(request: accounting.ReloadFinancialSummaryRequest): void {
    this.fourd.call4Dv2('accounting.reloadFinancialSummary', request);
  }

  reloadTimeFeeList(request: accounting.ReloadTimeFeeListRequest): void {
    this.fourd.call4Dv2('accounting.reloadTimeFeeList', request);
  }

  reloadOfficeLedger(request: accounting.ReloadOfficeLedgerRequest): void {
    this.fourd.call4Dv2('accounting.reloadOfficeLedger', request);
  }

  reloadAnticipatedPaymentList(request: accounting.ReloadAnticipatedPaymentListRequest): void {
    this.fourd.call4Dv2('accounting.reloadAnticipatedPaymentList', request);
  }

  reloadCostRecoveryList(request: accounting.ReloadCostRecoveryListRequest): void {
    this.fourd.call4Dv2('accounting.reloadCostRecoveryList', request);
  }

  reloadTrustLedger(request: accounting.ReloadTrustLedgerRequest): void {
    this.fourd.call4Dv2('accounting.reloadTrustLedger', request);
  }

  reloadControlledMoneyList(request: accounting.ReloadControlledMoneyListRequest): void {
    this.fourd.call4Dv2('accounting.reloadControlledMoneyList', request);
  }

  reloadPowerMoneyList(request: accounting.ReloadPowerMoneyListRequest): void {
    this.fourd.call4Dv2('accounting.reloadPowerMoneyList', request);
  }

  reloadTransitMoneyList(request: accounting.ReloadTransitMoneyListRequest): void {
    this.fourd.call4Dv2('accounting.reloadTransitMoneyList', request);
  }

  openFee(request: accounting.OpenFeeRequest): void {
    if (request.isAutoTime) request.timed = true;

    this.fourd.call4Dv2('accounting.openFee', request);
  }

  async createTimeEntryV2(request: accounting.CreateTimeEntryRequest): Promise<accounting.CreateTimeEntryResponse> {
    return await this.CreateItems<accounting.CreateFeeEntryRequest, accounting.CreateTimeEntryResponse>(
      request,
      'accounting.createTimeEntryV2'
    );
  }

  async createFeeEntryV2(request: accounting.CreateFeeEntryRequest): Promise<accounting.CreateFeeEntryResponse> {
    return await this.CreateItems<accounting.CreateFeeEntryRequest, accounting.CreateFeeEntryResponse>(
      request,
      'accounting.createFeeEntryV2'
    );
  }

  async createCostRecoveryV2(
    request: accounting.CreateCostRecoveryEntryRequest
  ): Promise<accounting.CreateCostRecoveryResponse> {
    return await this.CreateItems<accounting.CreateCostRecoveryEntryRequest, accounting.CreateCostRecoveryResponse>(
      request,
      'accounting.createCostRecoveryV2'
    );
  }

  async createInvoiceV2(request: accounting.CreateInvoiceRequest): Promise<accounting.CreateInvoiceResponse> {
    return await this.CreateItems<accounting.CreateInvoiceRequest, accounting.CreateInvoiceResponse>(
      request,
      'accounting.createInvoiceV2'
    );
  }

  async createOfficeReceiptV2(
    request: accounting.CreateOfficeReceiptRequest
  ): Promise<accounting.CreateOfficeReceiptResponse> {
    return await this.CreateItems<accounting.CreateOfficeReceiptRequest, accounting.CreateOfficeReceiptResponse>(
      request,
      'accounting.createOfficeReceiptV2'
    );
  }

  async createOfficePaymentV2(
    request: accounting.CreateOfficePaymentRequest
  ): Promise<accounting.CreateOfficePaymentResponse> {
    return await this.CreateItems<accounting.CreateOfficePaymentRequest, accounting.CreateOfficePaymentResponse>(
      request,
      'accounting.createOfficePaymentV2'
    );
  }

  async createOfficeJournalV2(
    request: accounting.CreateOfficeJournalRequest
  ): Promise<accounting.CreateOfficeJournalResponse> {
    return await this.CreateItems<accounting.CreateOfficeJournalRequest, accounting.CreateOfficeJournalResponse>(
      request,
      'accounting.createOfficeJournalV2'
    );
  }
  async createTrustReceiptV2(
    request: accounting.CreateTrustReceiptRequest
  ): Promise<accounting.CreateTrustReceiptResponse> {
    return await this.CreateItems<accounting.CreateTrustReceiptRequest, accounting.CreateTrustReceiptResponse>(
      request,
      'accounting.createTrustReceiptV2'
    );
  }

  async createTrustPaymentV2(
    request: accounting.CreateTrustPaymentRequest
  ): Promise<accounting.CreateTrustPaymentResponse> {
    return await this.CreateItems<accounting.CreateTrustPaymentRequest, accounting.CreateTrustPaymentResponse>(
      request,
      'accounting.createTrustPaymentV2'
    );
  }

  async createTrustJournalV2(
    request: accounting.CreateTrustJournalRequest
  ): Promise<accounting.CreateTrustJournalResponse> {
    return await this.CreateItems<accounting.CreateTrustJournalRequest, accounting.CreateTrustJournalResponse>(
      request,
      'accounting.createTrustJournalV2'
    );
  }

  async createTrustToOfficeV2(
    request: accounting.CreateTrustToOfficeRequest
  ): Promise<accounting.CreateTrustToOfficeResponse> {
    return await this.CreateItems<accounting.CreateTrustToOfficeRequest, accounting.CreateTrustToOfficeResponse>(
      request,
      'accounting.createTrustToOfficeV2'
    );
  }

  async createOfficePaymentRequestV2(
    request: accounting.CreateNewOfficePaymentRequestRequest
  ): Promise<accounting.CreateNewOfficePaymentRequestResponse> {
    return await this.CreateItems<
      accounting.CreateNewOfficePaymentRequestRequest,
      accounting.CreateNewOfficePaymentRequestResponse
    >(request, 'accounting.createOfficePaymentRequestV2');
  }

  async createTrustPaymentRequestV2(
    request: accounting.CreateNewTrustPaymentRequestRequest
  ): Promise<accounting.CreateNewTrustPaymentRequestResponse> {
    return await this.CreateItems<
      accounting.CreateNewTrustPaymentRequestRequest,
      accounting.CreateNewTrustPaymentRequestResponse
    >(request, 'accounting.createTrustPaymentRequestV2');
  }

  private async CreateItems<I, O>(request: I, command: string): Promise<O> {
    return this.fourd.twoWayCall<I, O>(
      request,
      (requestId, request) => {
        this.fourd.call4Dv2(command, request, requestId);
      },
      (response) => {
        return response;
      }
    );
  }
}
